export default __webpack_public_path__ + "static/media/f6.2e081fbd.jpg";